import styled from 'styled-components';

export const Links = styled.div.attrs({
  className: 'Links',
  direction: props => props.direction,
  family: props => props.family,
  size: props => props.size,
  weight: props => props.weight,
  lineheight: props => props.lineheight,
  color: props => props.color
})`
  display: flex;
  flex-direction: ${props => props.direction};
  flex-wrap: wrap;
  justify-content: space-evenly;
  font-family: ${props => props.family};
  font-size: ${props => props.size};
  font-weight: ${props => props.weight};
  line-height: ${props => props.lineheight};
  a {
    text-decoration: none;
    color: ${props => props.color};
  }
`;
